/**
 * Diz a um componente se o painel dele é o da aba à vista.
 *
 * Papel: o contexto que o `QuadroEmbutido` preenche em cada painel e o
 * `useAbaVisivel` que os componentes de dentro leem — o equivalente ao
 * `currentTab` da origem, que só desenhava a aba ativa.
 *
 * Como usar: um componente que deverá fazer algo ao abrir a aba dele — e não ao
 * montar a página, porque todo painel fica montado o tempo todo — lê
 * `useAbaVisivel()` num efeito. Fora de um `QuadroEmbutido`, o valor é
 * verdadeiro: o componente sozinho está à vista.
 */
import { createContext, useContext } from 'react';

/** Preenchido pelo `QuadroEmbutido`, um por painel. */
export const ContextoDaAbaVisivel = createContext(true);

/**
 * Diz se o painel em volta é o da aba à vista.
 *
 * @returns Verdadeiro na aba ativa e fora de um quadro; falso num painel
 *   escondido.
 */
export function useAbaVisivel(): boolean {
  return useContext(ContextoDaAbaVisivel);
}
